import { api } from "../client";
import { Config, ConfigMutate } from "../types";
import {
  MessageThreadUserFields,
  MessageThreadUserExtraFields,
  PartialMessageThreadUserExtraFields,
  PartialMessageThreadUserFields,
} from "../schema";

type ApiRequestConfig = Config<
  MessageThreadUserFields,
  MessageThreadUserExtraFields
>;
type ApiRequestConfigMutate = ConfigMutate<
  PartialMessageThreadUserFields,
  PartialMessageThreadUserExtraFields
>;

export const getMessageThreadUsers = (config?: ApiRequestConfig) => {
  return api.get<MessageThreadUserFields, MessageThreadUserExtraFields>(
    `message_thread_users`,
    config
  );
};

export const getMessageThreadUser = (id: number, config?: ApiRequestConfig) => {
  return api.get<MessageThreadUserFields, MessageThreadUserExtraFields>(
    `message_thread_users/${id}`,
    config
  );
};

export const createMessageThreadUser = (config?: ApiRequestConfigMutate) => {
  return api.create<MessageThreadUserFields, MessageThreadUserExtraFields>(
    `message_thread_users`,
    config
  );
};

export const updateMessageThreadUser = (
  id: number,
  config?: ApiRequestConfigMutate
) => {
  return api.update<MessageThreadUserFields, MessageThreadUserExtraFields>(
    `message_thread_users/${id}`,
    config
  );
};

export const deleteMessageThreadUser = (id: number) => {
  return api.remove<MessageThreadUserFields, MessageThreadUserExtraFields>(
    `message_thread_users/${id}?setting[with_deleted]=true`
  );
};
